<template>
  <div>
    <!-- User Email -->
    <text-input
      id="user-email"
      name="Email"
      placeholder="Email"
      rules="required|email"
      :text.sync="user.email"
    />

    <!-- Roles Select -->
    <roles-select
      :role.sync="rolesProxy"
      rules="required"
      multiple
    />

    <!-- Limited Events Access -->
    <b-checkbox
      id="limited-event-access"
      v-model="accessScopeProxy"
      class="my-2"
      value="event"
      unchecked-value="organization"
      :disabled="isUserAdmin"
    >
      Limited events access
    </b-checkbox>

    <!-- Events Select -->
    <div>
      <event-select
        multiple
        :event.sync="user.events"
        :disabled="user.accessScope==='organization'"
        :filter="{organizationTeam:$orgId}"
      />
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/FormInputs/TextInput.vue'
import EventSelect from '@/components/Events/EventSelect.vue'
import RolesSelect from '../Roles/RolesSelect.vue'

export default {
  name: 'UsersInviteInputs',
  components: { TextInput, EventSelect, RolesSelect },
  props: {
    user: { type: Object, default: () => {} },
  },
  computed: {
    rolesProxy: {
      get() {
        return this.user.roles
      },
      set(value) {
        this.$set(this.user, 'roles', value)
        if (this.isUserAdmin) {
          this.$set(this.user, 'events', null)
          this.$set(this.user, 'accessScope', 'organization')
        }
      },
    },
    accessScopeProxy: {
      get() {
        return this.user.accessScope
      },
      set(value) {
        if (value === 'organization') {
          this.$set(this.user, 'events', null)
        }
        this.$set(this.user, 'accessScope', value)
      },
    },
    isUserAdmin() {
      return this.user.roles.some(role => role.displayName === 'admin')
    },
  },
}
</script>

<style>

</style>
